import { CubePresenter, Logger } from 'wdc-cube';
import { ConceptScope } from '../../generic/concept.scope';
import { Places } from '../../route-consts';
const LOG = Logger.get('Mormaii.AccountPresenter');
/**
 * O CONCEITO "conta", que nao e uma tela.
 *
 * Sao quatro - entrar, criar, recuperar a senha e apagar a conta do app -, e as
 * quatro sao faces do mesmo assunto. Antes eram irmas na raiz, o que nao dizia
 * isso em lugar nenhum: `create-account` e `forgot-password` so se alcancam de
 * DENTRO do login, e nada na arvore registrava a relacao.
 *
 * Passagem, e nao aterrissagem: as quatro se substituem na tela, nenhuma fica por
 * baixo das outras. Quem para no conceito cai no login, que e a composicao padrao.
 * Ver `ConceptScope` para o criterio.
 *
 * Nao ha guarda aqui: a conta e justamente o que se alcanca SEM sessao.
 */
export class AccountPresenter extends CubePresenter {
    constructor(app) {
        super(app, new ConceptScope());
    }
    async applyParameters(intent, initialization, last) {
        if (initialization) {
            LOG.info('Initialized');
        }
        if (last) {
            // Ver a nota em `CollaboratorsPresenter`: `redirect` e nao `Keys.of`,
            // para nao perder o `next` que acabou de chegar.
            await this.app.flipToIntent(intent.redirect(Places.signIn));
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=account.presenter.js.map